import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.widget.machine.map');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface MachineCard {
    id: string;
    farm: string;
    model: string;
    workStart: string | null;
    workEnd: string | null;
}

interface MachineRegion {
    code: string;
    name: string;
    color: string;
    x: number;
    y: number;
    count: number;
    machines: MachineCard[];
    mapTransform?: string;
}

const MACHINE_REGIONS: Omit<MachineRegion, 'count' | 'machines'>[] = [
    { code: 'KR-11', name: '서울', color: '#e76f51', x: 314.1, y: 196.8 },
    { code: 'KR-26', name: '부산', color: '#2a9d8f', x: 620.7, y: 607.6 },
    { code: 'KR-27', name: '대구', color: '#f4a261', x: 545, y: 498.8 },
    { code: 'KR-28', name: '인천', color: '#457b9d', x: 258, y: 208 },
    { code: 'KR-29', name: '광주', color: '#9b5de5', x: 299.3, y: 621.8 },
    { code: 'KR-30', name: '대전', color: '#00b4d8', x: 372.8, y: 413 },
    { code: 'KR-31', name: '울산', color: '#43aa8b', x: 629.8, y: 557 },
    { code: 'KR-50', name: '세종', color: '#e9c46a', x: 350.9, y: 383.4 },
    { code: 'KR-41', name: '경기', color: '#5c7cfa', x: 343.7, y: 259.1 },
    { code: 'KR-42', name: '강원', color: '#52b788', x: 509.6, y: 179 },
    { code: 'KR-43', name: '충북', color: '#f9844a', x: 409.9, y: 327.2 },
    { code: 'KR-44', name: '충남', color: '#f9c74f', x: 291.5, y: 358.2 },
    { code: 'KR-45', name: '전북', color: '#ef476f', x: 338.1, y: 519 },
    { code: 'KR-46', name: '전남', color: '#90be6d', x: 356.1, y: 637.2 },
    { code: 'KR-47', name: '경북', color: '#577590', x: 572.5, y: 394.6 },
    { code: 'KR-48', name: '경남', color: '#b56576', x: 462.4, y: 582.9 },
    { code: 'KR-49', name: '제주', color: '#f3722c', x: 606.1, y: 768.5, mapTransform: 'translate(360 -160)' }
];

@Component({
    selector: 'wiz-component-widget-machine-map',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.widget.machine.map/view.scss */
/* src/app/component.widget.machine.map/view.scss: no such file or directory */`],
})
export class ComponentWidgetMachineMapComponent implements OnInit {
    public regions: MachineRegion[] = MACHINE_REGIONS.map(region => ({ ...region, count: 0, machines: [] }));
    public loading = true;
    public error = false;
    public selectedRegionCode: string | null = null;
    public hoveredRegionCode: string | null = null;
    public readonly minMapZoom = 1;
    public readonly maxMapZoom = 1.8;
    public mapZoom = 1;
    public mapPanX = 0;
    public mapPanY = 0;
    public isMapDragging = false;
    public leftMachineCards: MachineCard[] = [];
    public rightMachineCards: MachineCard[] = [];

    private dragPointerId: number | null = null;
    private dragStartClientX = 0;
    private dragStartClientY = 0;
    private dragStartPanX = 0;
    private dragStartPanY = 0;
    private dragMoved = false;
    private suppressNextMapClick = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    private async load(): Promise<void> {
        const response = await wiz.call('distribution');
        if (!response || response.code !== 200) {
            this.error = true;
            this.loading = false;
            return;
        }

        const regionData = new Map<string, { count: number; machines: MachineCard[] }>();
        for (const item of (response.data?.regions || [])) {
            const count = Number(item?.count ?? 0);
            if (!item?.code || !Number.isFinite(count)) continue;

            const machines = Array.isArray(item?.machines)
                ? item.machines.map((machine: any) => ({
                    id: String(machine?.id ?? ''),
                    farm: String(machine?.farm || '농장명 없음'),
                    model: String(machine?.model || '모델명 없음'),
                    workStart: machine?.workStart ? String(machine.workStart) : null,
                    workEnd: machine?.workEnd ? String(machine.workEnd) : null
                }))
                : [];
            regionData.set(item.code, {
                count: Math.max(0, Math.floor(count)),
                machines
            });
        }

        this.regions = MACHINE_REGIONS.map(region => ({
            ...region,
            count: regionData.get(region.code)?.count ?? 0,
            machines: regionData.get(region.code)?.machines ?? []
        }));
        this.loading = false;
    }

    public selectRegion(code: string): void {
        this.selectedRegionCode = this.selectedRegionCode === code ? null : code;
        this.updateSelectedMachineCards();
        this.service.render();
    }

    private updateSelectedMachineCards(): void {
        const machines = this.regions.find(region => region.code === this.selectedRegionCode)?.machines ?? [];
        this.leftMachineCards = machines.filter((_machine, index) => index % 2 === 0);
        this.rightMachineCards = machines.filter((_machine, index) => index % 2 === 1);
    }

    public trackMachine(_index: number, machine: MachineCard): string {
        return machine.id;
    }

    public trackRegion(_index: number, region: MachineRegion): string {
        return region.code;
    }

    public isRegionActive(code: string): boolean {
        return this.selectedRegionCode === code || this.hoveredRegionCode === code;
    }

    public getRegionScale(code: string): string {
        if (this.selectedRegionCode === code) return 'scale(1.045)';
        if (this.hoveredRegionCode === code) return 'scale(1.025)';
        return 'scale(1)';
    }

    public getRegionShadow(code: string): string {
        if (this.selectedRegionCode === code) return 'drop-shadow(0 5px 7px rgb(53 64 82 / 28%))';
        if (this.hoveredRegionCode === code) return 'drop-shadow(0 4px 6px rgb(53 64 82 / 24%))';
        return 'none';
    }

    public getLabelShadow(code: string): string {
        if (this.selectedRegionCode === code) return 'drop-shadow(0 2px 3px rgb(53 64 82 / 32%))';
        if (this.hoveredRegionCode === code) return 'drop-shadow(0 2px 3px rgb(53 64 82 / 28%))';
        return 'none';
    }

    public getMapZoomTransform(): string {
        return `translate(${480 + this.mapPanX} ${410.5 + this.mapPanY}) scale(${this.mapZoom}) translate(-480 -410.5)`;
    }

    public zoomIn(event: Event): void {
        event.stopPropagation();
        this.setMapZoom(this.mapZoom + 0.2);
    }

    public zoomOut(event: Event): void {
        event.stopPropagation();
        this.setMapZoom(this.mapZoom - 0.2);
    }

    private setMapZoom(zoom: number): void {
        const nextZoom = Math.min(this.maxMapZoom, Math.max(this.minMapZoom, zoom));
        this.mapZoom = Math.round(nextZoom * 10) / 10;
        this.clampMapPan();
        this.service.render();
    }

    public onMapClick(event: MouseEvent): void {
        if (this.suppressNextMapClick) {
            this.suppressNextMapClick = false;
            return;
        }

        const code = this.getRegionCodeFromEvent(event);
        if (code) this.selectRegion(code);
    }

    public onMapKeydown(event: KeyboardEvent): void {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        const code = this.getRegionCodeFromEvent(event);
        if (!code) return;

        event.preventDefault();
        this.selectRegion(code);
    }

    public onMapMouseOver(event: MouseEvent): void {
        if (this.isMapDragging) return;

        const code = this.getRegionCodeFromEvent(event);
        if (!code || code === this.hoveredRegionCode) return;

        this.hoveredRegionCode = code;
        this.service.render();
    }

    public onMapMouseOut(event: MouseEvent): void {
        if (this.isMapDragging) return;

        const code = this.getRegionCodeFromEvent(event);
        const relatedCode = this.getRegionCodeFromTarget(event.relatedTarget);
        if (!code || code !== this.hoveredRegionCode || relatedCode === code) return;

        this.hoveredRegionCode = null;
        this.service.render();
    }

    public onMapFocusIn(event: FocusEvent): void {
        const code = this.getRegionCodeFromEvent(event);
        if (!code || code === this.hoveredRegionCode) return;

        this.hoveredRegionCode = code;
        this.service.render();
    }

    public onMapFocusOut(event: FocusEvent): void {
        const code = this.getRegionCodeFromEvent(event);
        const relatedCode = this.getRegionCodeFromTarget(event.relatedTarget);
        if (!code || code !== this.hoveredRegionCode || relatedCode === code) return;

        this.hoveredRegionCode = null;
        this.service.render();
    }

    public onMapPointerDown(event: PointerEvent): void {
        if (event.button !== 0 || this.mapZoom <= this.minMapZoom) return;

        const target = event.target;
        if (target instanceof Element && target.closest('.machine-map-zoom-controls')) return;

        this.dragPointerId = event.pointerId;
        this.dragStartClientX = event.clientX;
        this.dragStartClientY = event.clientY;
        this.dragStartPanX = this.mapPanX;
        this.dragStartPanY = this.mapPanY;
        this.dragMoved = false;
    }

    public onMapPointerMove(event: PointerEvent): void {
        if (event.pointerId !== this.dragPointerId) return;

        const stage = event.currentTarget as HTMLElement;
        const bounds = stage.getBoundingClientRect();
        const deltaX = event.clientX - this.dragStartClientX;
        const deltaY = event.clientY - this.dragStartClientY;
        if (Math.hypot(deltaX, deltaY) < 4) return;

        if (!this.dragMoved) {
            stage.setPointerCapture(event.pointerId);
            this.dragMoved = true;
            this.isMapDragging = true;
            this.hoveredRegionCode = null;
        }

        this.mapPanX = this.dragStartPanX + deltaX * (800.82 / bounds.width);
        this.mapPanY = this.dragStartPanY + deltaY * (825 / bounds.height);
        this.clampMapPan();
        this.service.render();
    }

    public onMapPointerUp(event: PointerEvent): void {
        if (event.pointerId !== this.dragPointerId) return;

        this.suppressNextMapClick = this.dragMoved;
        if (this.dragMoved) {
            setTimeout(() => {
                this.suppressNextMapClick = false;
            }, 0);
        }
        this.finishMapDrag(event);
    }

    public onMapPointerCancel(event: PointerEvent): void {
        if (event.pointerId !== this.dragPointerId) return;

        this.suppressNextMapClick = false;
        this.finishMapDrag(event);
    }

    private finishMapDrag(event: PointerEvent): void {
        const stage = event.currentTarget as HTMLElement;
        const shouldRender = this.isMapDragging;
        if (stage.hasPointerCapture(event.pointerId)) {
            stage.releasePointerCapture(event.pointerId);
        }

        this.dragPointerId = null;
        this.dragMoved = false;
        this.isMapDragging = false;
        if (shouldRender) this.service.render();
    }

    private clampMapPan(): void {
        const maxPanX = 800.82 * (this.mapZoom - 1) / 2;
        const maxPanY = 825 * (this.mapZoom - 1) / 2;
        this.mapPanX = Math.min(maxPanX, Math.max(-maxPanX, this.mapPanX));
        this.mapPanY = Math.min(maxPanY, Math.max(-maxPanY, this.mapPanY));
    }

    private getRegionCodeFromEvent(event: Event): string | null {
        return this.getRegionCodeFromTarget(event.target);
    }

    private getRegionCodeFromTarget(target: EventTarget | null): string | null {
        if (!(target instanceof Element)) return null;

        return target.closest('.machine-map-region, .machine-map-label')
            ?.getAttribute('data-region-code') ?? null;
    }
}

export default ComponentWidgetMachineMapComponent;